import { Button, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IRequestPushSettingsProps {
  open?: boolean;
  onSkipClick(): void;
  onOpenSettingsClick(): void;
}

export const RequestPushSettings: React.VFC<IRequestPushSettingsProps> = props => {
  const { open, onOpenSettingsClick, onSkipClick } = props;

  return (
    <ModalWindow
      open={open}
      onClose={onSkipClick}
      title="Включить уведомления в настройках телефона"
      content={
        <div className={styles['content']} data-name="request_push_settings_modal">
          <Button theme="fill_secondary" onClick={onSkipClick} fullWidth>
            Не хочу
          </Button>
          <Button theme="fill_primary" onClick={onOpenSettingsClick} fullWidth>
            Включить
          </Button>
        </div>
      }
    />
  );
};
